<template>
  <div class="ProgressIndicator">
    <ul ref="ul">
      <li v-for="(n, i) in total" :class="{ 'active': i + 1 === active }" v-bind:key="(n, i)" :ref="`li_${ i + 1 }`">
        <div class="background">
          <div>{{ i + 1 }}</div>
        </div>
        <div :ref="`foreground_${ i + 1 }`" class="foreground">
          <div :ref="`foreground_inner_${ i + 1 }`">{{ i + 1 }}</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

import { TimelineLite, Expo, TweenLite } from 'gsap'

export default {
  name: 'ProgressIndicator',
  props: {
    total: Number,
    active: Number
  },
  data() {
    return {
      isMounted: false,
      activeNum: 1,
    }
  },
  mounted() {
    this.initIdleStates()
    this.createAnimationTimeline()
  },
  watch: {
    active: function( newVal, oldVal ) { // This should only change on the instructions page
      this.updateIndicator()
    }
  },
  computed: {
    cActive() { return this.activeNum }
  },
  methods: {
    initIdleStates() {
      if ( !this.active ) return

      const { ul } = this.$refs

      const activeForeground = this.$refs[`foreground_${ this.active }`]
      const activeForegroundInner = this.$refs[`foreground_inner_${ this.active }`]

      TweenLite.set( ul, { clipPath: 'polygon(50% 0%, 50% 0%, 50% 1px, 50% 1px)' } )
      TweenLite.set( activeForeground, { x: '0%', y: '100%' } )
      TweenLite.set( activeForegroundInner, { x: '0%', y: '-100%' } )

    },
    createAnimationTimeline() {
      if ( !this.active ) return

      const { ul } = this.$refs

      const activeForeground = this.$refs[`foreground_${ this.active }`]
      const activeForegroundInner = this.$refs[`foreground_inner_${ this.active }`]

      this.animateElementsIn = new TimelineLite( {} )

      this.animateElementsIn
        .to( ul, 0.3, { clipPath: 'polygon(0% 0%, 100% 0%, 100% 2px, 0% 2px)', ease: Expo.easeOut }, 0.3 )
        .to( ul, 0.3, { clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)', ease: Expo.easeOut }, 0.6 )
        .to( activeForeground, 1, { x: '0%', y: '0%', ease: Expo.easeOut }, 0.9 )
        .to( activeForegroundInner, 1, { x: '0%', y: '0%', ease: Expo.easeOut }, 0.9 )
    },
    updateIndicator() {
      if ( !this.active ) return

      const prevActiveForeground = this.$refs[`foreground_${ this.active - 1}`]
      const prevActiveForegroundInner = this.$refs[`foreground_inner_${ this.active - 1}`]
      const activeForeground = this.$refs[`foreground_${ this.active }`]
      const activeForegroundInner = this.$refs[`foreground_inner_${ this.active }`]

      new TimelineLite()
        .to( prevActiveForeground, 1.5, { x: '100%', ease: Expo.easeOut }, 0 )
        .to( prevActiveForegroundInner, 1.5, { x: '-100%', ease: Expo.easeOut }, 0 )

      new TimelineLite()
        .to( activeForeground, 1.5, { x: '0%', ease: Expo.easeOut }, 0 )
        .to( activeForegroundInner, 1.5, { x: '0%', ease: Expo.easeOut }, 0 )
    }
  }
}
</script>

<style scoped lang="scss">

  @import '@/styles/core.scss';

  .ProgressIndicator {

    ul {

      list-style: none;

      padding: 0;
      margin-top: rem( 20 );

      display: inline-flex;

      @include breakpoint-width( 375px, 667px ) {

        margin-top: rem(10 );

      }

      li {
        $border-size: 2px;

        position: relative;
        overflow: hidden;

        display: block;

        font-size: rem( 22 );
        font-weight: 300;

        .background,
        .foreground {
          div {
            position: relative;
            width: 100%;
            height: 100%;
            padding: rem( 10 ) rem( 20 );
          }
        }

        &:not(:last-of-type) .background div { border-right-color: transparent; }

        .foreground {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;

          overflow: hidden;
          transform: translateX(-100%);
        }

        .background div {
          border: solid $border-size currentColor;
          color: rgba($color-white, 0.5);
        }

        .foreground div {
          border: solid $border-size rgba($color-white, 0.65);
          background: rgba($color-white, 0.15);

          color: rgba($color-white, 1);

          transform: translateX(100%);
        }

      }

    }

  }

</style>
